var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
var Radio = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1.3em;\n  width: 1.3em;\n  border-radius: 50%;\n  background-color: ", ";\n  &:after {\n    content: '';\n    position: absolute;\n    display: none;\n    top: 0.4em;\n    left: 0.42em;\n    width: 0.5em;\n    height: 0.5em;\n    border-radius: 50%;\n    background-color: ", ";\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1.3em;\n  width: 1.3em;\n  border-radius: 50%;\n  background-color: ", ";\n  &:after {\n    content: '';\n    position: absolute;\n    display: none;\n    top: 0.4em;\n    left: 0.42em;\n    width: 0.5em;\n    height: 0.5em;\n    border-radius: 50%;\n    background-color: ", ";\n  }\n"])), function (p) {
  return p.theme.themeName === 'dark' ? p.theme.colorLevel(p.theme.lowContrast, 5) : p.theme.colorLevel(p.theme.lowContrast, 0.5);
}, function (p) {
  return p.theme.white;
});
/*
  &:hover ~ span.radio {
    background-color: ${(p) => p.theme.colorLevel(p.theme.lowContrast, 2)};
  }
*/

var Input = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n\n  &:hover:not(:disabled) {\n    & ~ span.radio {\n      background-color: ", ";\n    }\n\n    &:checked ~ span.radio {\n      background-color: ", ";\n    }\n  }\n\n  &:focus ~ span.radio {\n    box-shadow: ", "\n      ", ";\n  }\n  &:checked ~ span.radio {\n    background-color: ", ";\n    &:after {\n      display: block;\n    }\n  }\n"], ["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n\n  &:hover:not(:disabled) {\n    & ~ span.radio {\n      background-color: ", ";\n    }\n\n    &:checked ~ span.radio {\n      background-color: ", ";\n    }\n  }\n\n  &:focus ~ span.radio {\n    box-shadow: ", "\n      ", ";\n  }\n  &:checked ~ span.radio {\n    background-color: ", ";\n    &:after {\n      display: block;\n    }\n  }\n"])), function (p) {
  return p.theme.colorLevel(p.theme.lowContrast, 2);
}, function (p) {
  return p.theme.colorLevel(p.theme.themeName === 'dark' || p.theme.themeName === 'newlight' ? p.theme.primaryB : p.theme.themeName === 'greenlight' ? p.theme.primaryB : p.theme.primary, 2);
}, function (p) {
  return p.theme.inputFocusShadow;
}, function (p) {
  return p.theme.colorLevel(p.theme.themeName === 'dark' || p.theme.themeName === 'newlight' ? p.theme.primaryB : p.theme.themeName === 'greenlight' ? p.theme.primaryB : p.theme.primary, -5);
}, function (p) {
  return p.theme.themeName === 'dark' || p.theme.themeName === 'newlight' ? p.theme.primaryB : p.theme.themeName === 'greenlight' ? p.theme.primaryB : p.theme.primary;
});
var Wrapper = styled.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: start;\n  margin: 0.5em 0 0.5em 0;\n  position: relative;\n  padding-left: 2em;\n  user-select: none;\n"], ["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: start;\n  margin: 0.5em 0 0.5em 0;\n  position: relative;\n  padding-left: 2em;\n  user-select: none;\n"])));

var InputRadio = function InputRadio(_a) {
  var inputRef = _a.inputRef,
      name = _a.name,
      label = _a.label,
      value = _a.value,
      props = __rest(_a, ["inputRef", "name", "label", "value"]);

  return React.createElement(Wrapper, null, label, React.createElement(Input, Object.assign({
    ref: inputRef,
    className: "input-radio",
    type: "radio",
    name: name,
    value: value
  }, props)), React.createElement(Radio, {
    className: "radio"
  }));
};

export default InputRadio;
var templateObject_1, templateObject_2, templateObject_3;